// // components/dashboard/SalespersonStageDashboard.jsx
// import React, { useState, useEffect, useCallback } from 'react';
// import { Award, Target, Download, Search,
//   Users, ArrowUpDown, ChevronUp, ChevronDown 
// } from 'lucide-react';
// import { HiInboxStack } from "react-icons/hi2";
// import api from '../../common/apiClient';
// import SummaryApi from '../../common/SummaryApi';
// import { exportToPDF, exportToExcel } from './ExportData';
// import { Menu } from '@headlessui/react';

// const SalespersonStageDashboard = () => {
//   const [activeTab, setActiveTab] = useState('all');
//   const [divisions, setDivisions] = useState([]);
//   const [salespersonData, setSalespersonData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filterType, setFilterType] = useState('fiscal');
//   const [dateRange, setDateRange] = useState({ from: '', to: '' });
//   const [searchTerm, setSearchTerm] = useState('');
//   const [sortConfig, setSortConfig] = useState({ key: 'totalAmount', direction: 'desc' });
//   const [orgDetails, setOrgDetails] = useState({ });
  
//   const fetchOrganization = useCallback(async () => {
//     try {
//       const response =await api.get(SummaryApi.getOrgDetails.url);
//       if (response.data.success) {
//         setOrgDetails(response.data.organization);
//       }
//     } catch (error) {
//       console.error("Error fetching organization:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, []); // dependencies empty → stable reference

//   // ✅ useEffect to call once on mount
//   useEffect(() => {
//     fetchOrganization();
//   }, [fetchOrganization]);
  
//   const handleExport = (format) => {
//     const divisionName = activeTab === 'all' 
//       ? 'All Divisions' 
//       : divisions.find(d => d._id === activeTab)?.name || activeTab;

//     if (format === 'pdf') {
//       exportToPDF(filteredAndSortedData, allStages, totals, filterType, divisionName, orgDetails);
//     } else if (format === 'excel') {
//       exportToExcel(filteredAndSortedData, allStages, totals, filterType, divisionName);
//     }
//   };

//   // Fetch divisions
//   const fetchDivisions = useCallback(async () => {
//     try {
//       const response = await api.get(SummaryApi.getAllDivisions.url);
//       if (response.data.success) {
//         setDivisions(response.data.data || []);
//       }
//     } catch (error) {
//       console.error('Failed to fetch divisions:', error);
//     }
//   }, []);

//   // Fetch salesperson stage data
//   const fetchSalespersonStageData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams({
//         filterType,
//         ...(activeTab !== 'all' && { divisionId: activeTab }),
//         ...(dateRange.from && { fromDate: dateRange.from }),
//         ...(dateRange.to && { toDate: dateRange.to })
//       });

//       const response = await api.get(`${SummaryApi.getSalespersonStageDashboard.url}?${params.toString()}`);
//       if (response.data.success) {
//         setSalespersonData(response.data.data || []);
//       }
//     } catch (error) {
//       console.error('Failed to fetch salesperson stage data:', error);
//     } finally {
//       setLoading(false);
//     }
//   }, [activeTab, filterType, dateRange]);

//   useEffect(() => {
//     fetchDivisions();
//   }, [fetchDivisions]);

//   useEffect(() => {
//     fetchSalespersonStageData();
//   }, [fetchSalespersonStageData]);

//   // Sort function
//   const handleSort = (key) => {
//     setSortConfig({
//       key,
//       direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc'
//     });
//   };

//   // Filter and sort data
//   const filteredAndSortedData = React.useMemo(() => {
//     let filtered = salespersonData.filter(person => 
//       person.userName.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     // Sort data
//     return filtered.sort((a, b) => {
//       let aValue = a[sortConfig.key];
//       let bValue = b[sortConfig.key];

//       // For stage-specific sorting
//       if (sortConfig.key.includes('stage_')) {
//         const stageId = sortConfig.key.replace('stage_', '');
//         const aStage = a.stages.find(s => s.stageId === stageId);
//         const bStage = b.stages.find(s => s.stageId === stageId);
//         aValue = aStage ? aStage.totalAmount : 0;
//         bValue = bStage ? bStage.totalAmount : 0;
//       }

//       if (sortConfig.direction === 'asc') {
//         return aValue > bValue ? 1 : -1;
//       } else {
//         return aValue < bValue ? 1 : -1;
//       }
//     });
//   }, [salespersonData, searchTerm, sortConfig]);

//   // Calculate top performers
//   const topPerformers = [...salespersonData]
//     .sort((a, b) => b.totalAmount - a.totalAmount)
//     .slice(0, 3);

//   // Calculate stage totals
//   const stageTotals = salespersonData.reduce((acc, person) => {
//     person.stages.forEach(stage => {
//       if (!acc[stage.stageId]) {
//         acc[stage.stageId] = {
//           ...stage,
//           totalDeals: 0,
//           totalAmount: 0
//         };
//       }
//       acc[stage.stageId].totalDeals += stage.totalDeals;
//       acc[stage.stageId].totalAmount += stage.totalAmount;
//     });
//     return acc;
//   }, {});

//   // Get totals
//   const totals = salespersonData.reduce((acc, person) => ({
//     deals: acc.deals + person.totalDeals,
//     amount: acc.amount + person.totalAmount
//   }), { deals: 0, amount: 0 });

//   // Get all unique stages
//   const allStages = salespersonData.length > 0 ? salespersonData[0].stages : [];

//   const SortIcon = ({ columnKey }) => {
//     if (sortConfig.key !== columnKey) {
//       return <ArrowUpDown className="h-3 w-3 text-gray-400" />;
//     }
//     return sortConfig.direction === 'asc' 
//       ? <ChevronUp className="h-3 w-3 text-red-600" />
//       : <ChevronDown className="h-3 w-3 text-red-600" />;
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-96">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-6 p-6">
//       {/* Header */}
//       <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900">Salesperson Performance Dashboard</h1>
//           <p className="text-gray-600 mt-1">Track individual sales performance across stages</p>
//         </div>
        
//         <div className="flex flex-wrap items-center gap-3">
//           {/* Search */}
//           <div className="relative">
//             <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
//             <input
//               type="text"
//               placeholder="Search salesperson..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500 w-64"
//             />
//           </div>

//           {/* Filter Type Selector */}
//           <select
//             value={filterType}
//             onChange={(e) => setFilterType(e.target.value)}
//             className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//           >
//             <option value="fiscal">Fiscal Year</option>
//             <option value="month">This Month</option>
//             <option value="year">This Year</option>
//             <option value="custom">Custom Range</option>
//           </select>

//           {/* Custom Date Range */}
//           {filterType === 'custom' && (
//             <>
//               <input
//                 type="date"
//                 value={dateRange.from}
//                 onChange={(e) => setDateRange(prev => ({ ...prev, from: e.target.value }))}
//                 className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//               />
//               <span className="text-gray-500">to</span>
//               <input
//                 type="date"
//                 value={dateRange.to}
//                 onChange={(e) => setDateRange(prev => ({ ...prev, to: e.target.value }))}
//                 className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//               />
//             </>
//           )}

//           {/* Export Button */}
//   <Menu as="div" className="relative inline-block text-left">
//     <Menu.Button className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm">
//       <Download className="h-4 w-4 text-gray-600" />
//       Export
//       <ChevronDown className="h-4 w-4 text-gray-400" />
//     </Menu.Button>
    
//     <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
//       <div className="px-1 py-1">
//         <Menu.Item>
//           {({ active }) => (
//             <button
//               onClick={() => handleExport('pdf')}
//               className={`${
//                 active ? 'bg-red-50 text-red-600' : 'text-gray-900'
//               } group flex w-full items-center rounded-md px-3 py-2 text-sm transition-colors`}
//             >
//               <svg className="mr-3 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
//                   d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
//               </svg>
//               Export as PDF
//             </button>
//           )}
//         </Menu.Item>
        
//         <Menu.Item>
//           {({ active }) => (
//             <button
//               onClick={() => handleExport('excel')}
//               className={`${
//                 active ? 'bg-green-50 text-green-600' : 'text-gray-900'
//               } group flex w-full items-center rounded-md px-3 py-2 text-sm transition-colors`}
//             >
//               <svg className="mr-3 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
//                   d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
//               </svg>
//               Export as Excel
//             </button>
//           )}
//         </Menu.Item>
//       </div>
//     </Menu.Items>
//   </Menu>
//         </div>
//       </div>

//       {/* Division Tabs */}
//       <div className="border-b border-gray-200 overflow-x-auto">
//         <nav className="-mb-px flex space-x-8">
//           <button
//             onClick={() => setActiveTab('all')}
//             className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
//               activeTab === 'all'
//                 ? 'border-red-600 text-red-600'
//                 : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//             }`}
//           >
//             All Divisions
//           </button>
          
//           {divisions.map(division => (
//             <button
//               key={division._id}
//               onClick={() => setActiveTab(division._id)}
//               className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
//                 activeTab === division._id
//                   ? 'border-red-600 text-red-600'
//                   : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//               }`}
//             >
//               {division.name}
//             </button>
//           ))}
//         </nav>
//       </div>

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//         <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <Users className="h-8 w-8 opacity-80" />
//             <span className="text-2xl font-bold">{salespersonData.length}</span>
//           </div>
//           <p className="text-sm opacity-90">Active Salespersons</p>
//         </div>

//         <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <Target className="h-8 w-8 opacity-80" />
//             <span className="text-2xl font-bold">{totals.deals}</span>
//           </div>
//           <p className="text-sm opacity-90">Total Deals</p>
//         </div>

//         <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <HiInboxStack className="h-8 w-8 opacity-80" />
//             <span className="text-xl font-bold">₹{(totals.amount || 0).toLocaleString('en-IN')}</span>
//           </div>
//           <p className="text-sm opacity-90">Total Pipeline Value</p>
//         </div>

//         <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <Award className="h-8 w-8 opacity-80" />
//             <span className="text-lg font-bold">{topPerformers[0]?.userName.split(' ')[0] || '-'}</span>
//           </div>
//           <p className="text-sm opacity-90">Top Performer</p>
//         </div>
//       </div>

//       {/* Pipeline Overview */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//         <h2 className="text-lg font-semibold text-gray-900 mb-4">Pipeline Overview</h2>
//         <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
//           {Object.values(stageTotals).map(stage => (
//             <div
//               key={stage.stageId}
//               className="text-center p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow"
//               style={{ borderTopColor: stage.color, borderTopWidth: '3px' }}
//             >
//               <div 
//                 className="w-3 h-3 rounded-full mx-auto mb-2"
//                 style={{ backgroundColor: stage.color }}
//               />
//               <p className="text-xs text-gray-600 mb-1">{stage.stageName}</p>
//               <p className="text-xl font-bold text-gray-900">{stage.totalDeals}</p>
//               <p className="text-xs text-gray-500 mt-1">
//                 ₹{(stage.totalAmount || 0).toLocaleString('en-IN')}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Performance Table */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
//         <div className="p-6 border-b border-gray-200">
//           <h2 className="text-lg font-semibold text-gray-900">Individual Performance Details</h2>
//         </div>
        
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="bg-gray-50 border-b border-gray-200">
//               <tr>
//                 <th className="px-6 py-3 text-left">
//                   <button
//                     onClick={() => handleSort('userName')}
//                     className="flex items-center gap-1 text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
//                   >
//                     Salesperson
//                     <SortIcon columnKey="userName" />
//                   </button>
//                 </th>
//                 {allStages.map(stage => (
//                   <th key={stage.stageId} className="px-4 py-3 text-center">
//                     <button
//                       onClick={() => handleSort(`stage_${stage.stageId}`)}
//                       className="flex flex-col items-center gap-1 mx-auto group"
//                     >
//                       <div className="flex items-center gap-1">
//                         <div 
//                           className="w-2 h-2 rounded-full"
//                           style={{ backgroundColor: stage.color }}
//                         />
//                         <span className="text-xs font-medium text-gray-700 uppercase tracking-wider group-hover:text-red-600">
//                           {stage.stageId}
//                         </span>
//                         <SortIcon columnKey={`stage_${stage.stageId}`} />
//                       </div>
//                       <span className="text-[10px] text-gray-500 font-normal">
//                         {stage.stageName}
//                       </span>
//                     </button>
//                   </th>
//                 ))}
//                 <th className="px-6 py-3 text-center">
//                   <button
//                     onClick={() => handleSort('totalDeals')}
//                     className="flex items-center gap-1 mx-auto text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
//                   >
//                     Total Deals
//                     <SortIcon columnKey="totalDeals" />
//                   </button>
//                 </th>
//                 <th className="px-6 py-3 text-center">
//                   <button
//                     onClick={() => handleSort('totalAmount')}
//                     className="flex items-center gap-1 mx-auto text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
//                   >
//                     Total Amount
//                     <SortIcon columnKey="totalAmount" />
//                   </button>
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {filteredAndSortedData.length === 0 ? (
//                 <tr>
//                   <td colSpan={allStages.length + 3} className="px-6 py-12 text-center text-gray-500">
//                     No salesperson data found
//                   </td>
//                 </tr>
//               ) : (
//                 filteredAndSortedData.map((person, index) => (
//                   <tr key={person._id} className="hover:bg-gray-50 transition-colors">
//                     <td className="px-6 py-4">
//                       <div className="flex items-center gap-3">
//                         <div className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium ${
//                           index < 3 ? 'bg-red-100 text-red-600' : 'bg-gray-100 text-gray-600'
//                         }`}>
//                           {index + 1}
//                         </div>
//                         <div>
//                           <p className="text-sm font-medium text-gray-900">{person.userName}</p>
//                         </div>
//                       </div>
//                     </td>
//                     {person.stages.map(stage => (
//                       <td key={stage.stageId} className="px-4 py-4 text-center">
//                         {stage.totalDeals > 0 ? (
//                           <div className="inline-flex flex-col">
//                             <span className="text-sm font-medium text-gray-900">
//                               {stage.totalDeals}
//                             </span>
//                             <span className="text-xs text-gray-500">
//                               ₹{(stage.totalAmount || 0).toLocaleString('en-IN')}
//                             </span>
//                           </div>
//                         ) : (
//                           <span className="text-sm text-gray-400">-</span>
//                         )}
//                       </td>
//                     ))}
//                     <td className="px-6 py-4 text-center">
//                       <span className="text-sm font-bold text-gray-900">{person.totalDeals}</span>
//                     </td>
//                     <td className="px-6 py-4 text-center">
//                       <span className="text-sm font-bold text-gray-900">
//                         ₹{(person.totalAmount || 0).toLocaleString('en-IN')}
//                       </span>
//                     </td>
//                   </tr>
//                 ))
//               )}
              
//               {/* Total Row */}
//               {filteredAndSortedData.length > 0 && (
//                 <tr className="bg-gray-50 font-semibold">
//                   <td className="px-6 py-4">
//                     <span className="text-sm text-gray-900">Total</span>
//                   </td>
//                   {allStages.map(stage => {
//                     const stageTotal = stageTotals[stage.stageId] || { totalDeals: 0, totalAmount: 0 };
//                     return (
//                       <td key={stage.stageId} className="px-4 py-4 text-center">
//                         <div className="inline-flex flex-col">
//                           <span className="text-sm text-gray-900">
//                             {stageTotal.totalDeals}
//                           </span>
//                           <span className="text-xs text-gray-600">
//                             ₹{(stageTotal.totalAmount || 0).toLocaleString('en-IN')}
//                           </span>
//                         </div>
//                       </td>
//                     );
//                   })}
//                   <td className="px-6 py-4 text-center">
//                     <span className="text-sm text-gray-900">{totals.deals}</span>
//                   </td>
//                   <td className="px-6 py-4 text-center">
//                     <span className="text-sm text-gray-900">
//                       ₹{(totals.amount || 0).toLocaleString('en-IN')}
//                     </span>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalespersonStageDashboard;

// // components/dashboard/SalespersonStageDashboard.jsx
// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { Award, Target, Download, Search, Users, ArrowUpDown, ChevronUp, ChevronDown } from 'lucide-react';
// import { HiInboxStack } from "react-icons/hi2";
// import api from '../../common/apiClient';
// import SummaryApi from '../../common/SummaryApi';
// import { exportToPDF, exportToExcel } from './ExportData';
// import { Menu } from '@headlessui/react';
// import { SalespersonDashboardSkeleton } from './SkeletonLoader';

// const SalespersonStageDashboard = ({ viewType = 'all', userId = null, userName = '' }) => {
//   const [activeTab, setActiveTab] = useState('all');
//   const [divisions, setDivisions] = useState([]);
//   const [salespersonData, setSalespersonData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filterType, setFilterType] = useState('fiscal');
//   const [dateRange, setDateRange] = useState({ from: '', to: '' });
//   const [searchTerm, setSearchTerm] = useState('');
//   const [sortConfig, setSortConfig] = useState({ key: 'totalAmount', direction: 'desc' });
//   const [orgDetails, setOrgDetails] = useState({});
  
//   // Determine if we should show division tabs based on viewType
//   const showDivisionTabs = viewType === 'all';
//   const isUserView = viewType === 'user';

//   // Memoized title based on viewType
//   const dashboardTitle = useMemo(() => {
//     if (isUserView && userName) {
//       return `${userName}'s Performance Dashboard`;
//     }
//     return 'Salesperson Performance Dashboard';
//   }, [isUserView, userName]);

//   const fetchOrganization = useCallback(async () => {
//     try {
//       const response = await api.get(SummaryApi.getOrgDetails.url);
//       if (response.data.success) {
//         setOrgDetails(response.data.organization);
//       }
//     } catch (error) {
//       console.error("Error fetching organization:", error);
//     }
//   }, []);

//   // Single useEffect for organization fetch
//   useEffect(() => {
//     fetchOrganization();
//   }, [fetchOrganization]);

//     // Memoized computations
//   const filteredAndSortedData = useMemo(() => {
//     let filtered = salespersonData.filter(person => 
//       person.userName.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     return filtered.sort((a, b) => {
//       let aValue = a[sortConfig.key];
//       let bValue = b[sortConfig.key];

//       if (sortConfig.key.includes('stage_')) {
//         const stageId = sortConfig.key.replace('stage_', '');
//         const aStage = a.stages.find(s => s.stageId === stageId);
//         const bStage = b.stages.find(s => s.stageId === stageId);
//         aValue = aStage ? aStage.totalAmount : 0;
//         bValue = bStage ? bStage.totalAmount : 0;
//       }

//       return sortConfig.direction === 'asc' 
//         ? aValue > bValue ? 1 : -1 
//         : aValue < bValue ? 1 : -1;
//     });
//   }, [salespersonData, searchTerm, sortConfig]);
  

//   // Fetch divisions only if needed
//   const fetchDivisions = useCallback(async () => {
//     if (!showDivisionTabs) return;
    
//     try {
//       const response = await api.get(SummaryApi.getAllDivisions.url);
//       if (response.data.success) {
//         setDivisions(response.data.data || []);
//       }
//     } catch (error) {
//       console.error('Failed to fetch divisions:', error);
//     }
//   }, [showDivisionTabs]);

//   // Fetch salesperson stage data with viewType support
//   const fetchSalespersonStageData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams({
//         filterType,
//         ...(isUserView && userId && { userId }),
//         ...(activeTab !== 'all' && showDivisionTabs && { divisionId: activeTab }),
//         ...(dateRange.from && { fromDate: dateRange.from }),
//         ...(dateRange.to && { toDate: dateRange.to })
//       });

//       const response = await api.get(`${SummaryApi.getSalespersonStageDashboard.url}?${params.toString()}`);
//       if (response.data.success) {
//         setSalespersonData(response.data.data || []);
//       }
//     } catch (error) {
//       console.error('Failed to fetch salesperson stage data:', error);
//     } finally {
//       setLoading(false);
//     }
//   }, [activeTab, filterType, dateRange, isUserView, userId, showDivisionTabs]);

//   // Combined useEffect for data fetching
//   useEffect(() => {
//     if (showDivisionTabs) {
//       fetchDivisions();
//     }
//     fetchSalespersonStageData();
//   }, [fetchDivisions, fetchSalespersonStageData, showDivisionTabs]);

//   const topPerformers = useMemo(() => 
//     [...salespersonData].sort((a, b) => b.totalAmount - a.totalAmount).slice(0, 3),
//     [salespersonData]
//   );

//   const stageTotals = useMemo(() => {
//     return salespersonData.reduce((acc, person) => {
//       person.stages.forEach(stage => {
//         if (!acc[stage.stageId]) {
//           acc[stage.stageId] = {
//             ...stage,
//             totalDeals: 0,
//             totalAmount: 0
//           };
//         }
//         acc[stage.stageId].totalDeals += stage.totalDeals;
//         acc[stage.stageId].totalAmount += stage.totalAmount;
//       });
//       return acc;
//     }, {});
//   }, [salespersonData]);

//   const totals = useMemo(() => 
//     salespersonData.reduce((acc, person) => ({
//       deals: acc.deals + person.totalDeals,
//       amount: acc.amount + person.totalAmount
//     }), { deals: 0, amount: 0 }),
//     [salespersonData]
//   );

//   const allStages = useMemo(() => {
//     return salespersonData.length > 0 ? salespersonData[0].stages : [];
//   }, [salespersonData]);

//     const handleExport = useCallback((format) => {
//     const divisionName = activeTab === 'all' 
//       ? 'All Divisions' 
//       : divisions.find(d => d._id === activeTab)?.name || activeTab;

//     if (format === 'pdf') {
//       exportToPDF(filteredAndSortedData, allStages, totals, filterType, divisionName, orgDetails);
//     } else if (format === 'excel') {
//       exportToExcel(filteredAndSortedData, allStages, totals, filterType, divisionName);
//     }
//   }, [activeTab, divisions, filteredAndSortedData, allStages, totals, filterType, orgDetails]);


//   // Sort handler
//   const handleSort = useCallback((key) => {
//     setSortConfig(prev => ({
//       key,
//       direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
//     }));
//   }, []);

//   const SortIcon = ({ columnKey }) => {
//     if (sortConfig.key !== columnKey) {
//       return <ArrowUpDown className="h-3 w-3 text-gray-400" />;
//     }
//     return sortConfig.direction === 'asc' 
//       ? <ChevronUp className="h-3 w-3 text-red-600" />
//       : <ChevronDown className="h-3 w-3 text-red-600" />;
//   };

//   if (loading) {
//     return <SalespersonDashboardSkeleton />;
//   }

//   return (
//     <div className="space-y-6 p-6">
//       {/* Header */}
//       <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900">{dashboardTitle}</h1>
//           <p className="text-gray-600 mt-1">
//             {isUserView 
//               ? 'Track your personal sales performance across stages'
//               : 'Track individual sales performance across stages'
//             }
//           </p>
//         </div>
        
//         <div className="flex flex-wrap items-center gap-3">
//           {/* Search - Only show in 'all' view */}
//           {!isUserView && (
//             <div className="relative">
//               <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
//               <input
//                 type="text"
//                 placeholder="Search salesperson..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500 w-64"
//               />
//             </div>
//           )}

//           {/* Filter Type Selector */}
//           <select
//             value={filterType}
//             onChange={(e) => setFilterType(e.target.value)}
//             className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//           >
//             <option value="fiscal">Fiscal Year</option>
//             <option value="month">This Month</option>
//             <option value="year">This Year</option>
//             <option value="custom">Custom Range</option>
//           </select>

//           {/* Custom Date Range */}
//           {filterType === 'custom' && (
//             <>
//               <input
//                 type="date"
//                 value={dateRange.from}
//                 onChange={(e) => setDateRange(prev => ({ ...prev, from: e.target.value }))}
//                 className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//               />
//               <span className="text-gray-500">to</span>
//               <input
//                 type="date"
//                 value={dateRange.to}
//                 onChange={(e) => setDateRange(prev => ({ ...prev, to: e.target.value }))}
//                 className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//               />
//             </>
//           )}

//           {/* Export Button */}
//           <Menu as="div" className="relative inline-block text-left">
//             <Menu.Button className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm">
//               <Download className="h-4 w-4 text-gray-600" />
//               Export
//               <ChevronDown className="h-4 w-4 text-gray-400" />
//             </Menu.Button>
            
//             <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
//               <div className="px-1 py-1">
//                 <Menu.Item>
//                   {({ active }) => (
//                     <button
//                       onClick={() => handleExport('pdf')}
//                       className={`${
//                         active ? 'bg-red-50 text-red-600' : 'text-gray-900'
//                       } group flex w-full items-center rounded-md px-3 py-2 text-sm transition-colors`}
//                     >
//                       <svg className="mr-3 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
//                           d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
//                       </svg>
//                       Export as PDF
//                     </button>
//                   )}
//                 </Menu.Item>
                
//                 <Menu.Item>
//                   {({ active }) => (
//                     <button
//                       onClick={() => handleExport('excel')}
//                       className={`${
//                         active ? 'bg-green-50 text-green-600' : 'text-gray-900'
//                       } group flex w-full items-center rounded-md px-3 py-2 text-sm transition-colors`}
//                     >
//                       <svg className="mr-3 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
//                           d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
//                       </svg>
//                       Export as Excel
//                     </button>
//                   )}
//                 </Menu.Item>
//               </div>
//             </Menu.Items>
//           </Menu>
//         </div>
//       </div>

//       {/* Division Tabs */}
//       <div className="border-b border-gray-200 overflow-x-auto">
//         <nav className="-mb-px flex space-x-8">
//           <button
//             onClick={() => setActiveTab('all')}
//             className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
//               activeTab === 'all'
//                 ? 'border-red-600 text-red-600'
//                 : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//             }`}
//           >
//             All Divisions
//           </button>
          
//           {divisions.map(division => (
//             <button
//               key={division._id}
//               onClick={() => setActiveTab(division._id)}
//               className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
//                 activeTab === division._id
//                   ? 'border-red-600 text-red-600'
//                   : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//               }`}
//             >
//               {division.name}
//             </button>
//           ))}
//         </nav>
//       </div>

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//         <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <Users className="h-8 w-8 opacity-80" />
//             <span className="text-2xl font-bold">{salespersonData.length}</span>
//           </div>
//           <p className="text-sm opacity-90">Active Salespersons</p>
//         </div>

//         <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <Target className="h-8 w-8 opacity-80" />
//             <span className="text-2xl font-bold">{totals.deals}</span>
//           </div>
//           <p className="text-sm opacity-90">Total Deals</p>
//         </div>

//         <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <HiInboxStack className="h-8 w-8 opacity-80" />
//             <span className="text-xl font-bold">₹{(totals.amount || 0).toLocaleString('en-IN')}</span>
//           </div>
//           <p className="text-sm opacity-90">Total Pipeline Value</p>
//         </div>

//         <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <Award className="h-8 w-8 opacity-80" />
//             <span className="text-lg font-bold">{topPerformers[0]?.userName.split(' ')[0] || '-'}</span>
//           </div>
//           <p className="text-sm opacity-90">Top Performer</p>
//         </div>
//       </div>

//       {/* Pipeline Overview */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//         <h2 className="text-lg font-semibold text-gray-900 mb-4">Pipeline Overview</h2>
//         <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
//           {Object.values(stageTotals).map(stage => (
//             <div
//               key={stage.stageId}
//               className="text-center p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow"
//               style={{ borderTopColor: stage.color, borderTopWidth: '3px' }}
//             >
//               <div 
//                 className="w-3 h-3 rounded-full mx-auto mb-2"
//                 style={{ backgroundColor: stage.color }}
//               />
//               <p className="text-xs text-gray-600 mb-1">{stage.stageName}</p>
//               <p className="text-xl font-bold text-gray-900">{stage.totalDeals}</p>
//               <p className="text-xs text-gray-500 mt-1">
//                 ₹{(stage.totalAmount || 0).toLocaleString('en-IN')}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Performance Table */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
//         <div className="p-6 border-b border-gray-200">
//           <h2 className="text-lg font-semibold text-gray-900">Individual Performance Details</h2>
//         </div>
        
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="bg-gray-50 border-b border-gray-200">
//               <tr>
//                 <th className="px-6 py-3 text-left">
//                   <button
//                     onClick={() => handleSort('userName')}
//                     className="flex items-center gap-1 text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
//                   >
//                     Salesperson
//                     <SortIcon columnKey="userName" />
//                   </button>
//                 </th>
//                 {allStages.map(stage => (
//                   <th key={stage.stageId} className="px-4 py-3 text-center">
//                     <button
//                       onClick={() => handleSort(`stage_${stage.stageId}`)}
//                       className="flex flex-col items-center gap-1 mx-auto group"
//                     >
//                       <div className="flex items-center gap-1">
//                         <div 
//                           className="w-2 h-2 rounded-full"
//                           style={{ backgroundColor: stage.color }}
//                         />
//                         <span className="text-xs font-medium text-gray-700 uppercase tracking-wider group-hover:text-red-600">
//                           {stage.stageId}
//                         </span>
//                         <SortIcon columnKey={`stage_${stage.stageId}`} />
//                       </div>
//                       <span className="text-[10px] text-gray-500 font-normal">
//                         {stage.stageName}
//                       </span>
//                     </button>
//                   </th>
//                 ))}
//                 <th className="px-6 py-3 text-center">
//                   <button
//                     onClick={() => handleSort('totalDeals')}
//                     className="flex items-center gap-1 mx-auto text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
//                   >
//                     Total Deals
//                     <SortIcon columnKey="totalDeals" />
//                   </button>
//                 </th>
//                 <th className="px-6 py-3 text-center">
//                   <button
//                     onClick={() => handleSort('totalAmount')}
//                     className="flex items-center gap-1 mx-auto text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
//                   >
//                     Total Amount
//                     <SortIcon columnKey="totalAmount" />
//                   </button>
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {filteredAndSortedData.length === 0 ? (
//                 <tr>
//                   <td colSpan={allStages.length + 3} className="px-6 py-12 text-center text-gray-500">
//                     No salesperson data found
//                   </td>
//                 </tr>
//               ) : (
//                 filteredAndSortedData.map((person, index) => (
//                   <tr key={person._id} className="hover:bg-gray-50 transition-colors">
//                     <td className="px-6 py-4">
//                       <div className="flex items-center gap-3">
//                         <div className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium ${
//                           index < 3 ? 'bg-red-100 text-red-600' : 'bg-gray-100 text-gray-600'
//                         }`}>
//                           {index + 1}
//                         </div>
//                         <div>
//                           <p className="text-sm font-medium text-gray-900">{person.userName}</p>
//                         </div>
//                       </div>
//                     </td>
//                     {person.stages.map(stage => (
//                       <td key={stage.stageId} className="px-4 py-4 text-center">
//                         {stage.totalDeals > 0 ? (
//                           <div className="inline-flex flex-col">
//                             <span className="text-sm font-medium text-gray-900">
//                               {stage.totalDeals}
//                             </span>
//                             <span className="text-xs text-gray-500">
//                               ₹{(stage.totalAmount || 0).toLocaleString('en-IN')}
//                             </span>
//                           </div>
//                         ) : (
//                           <span className="text-sm text-gray-400">-</span>
//                         )}
//                       </td>
//                     ))}
//                     <td className="px-6 py-4 text-center">
//                       <span className="text-sm font-bold text-gray-900">{person.totalDeals}</span>
//                     </td>
//                     <td className="px-6 py-4 text-center">
//                       <span className="text-sm font-bold text-gray-900">
//                         ₹{(person.totalAmount || 0).toLocaleString('en-IN')}
//                       </span>
//                     </td>
//                   </tr>
//                 ))
//               )}
              
//               {/* Total Row */}
//               {filteredAndSortedData.length > 0 && (
//                 <tr className="bg-gray-50 font-semibold">
//                   <td className="px-6 py-4">
//                     <span className="text-sm text-gray-900">Total</span>
//                   </td>
//                   {allStages.map(stage => {
//                     const stageTotal = stageTotals[stage.stageId] || { totalDeals: 0, totalAmount: 0 };
//                     return (
//                       <td key={stage.stageId} className="px-4 py-4 text-center">
//                         <div className="inline-flex flex-col">
//                           <span className="text-sm text-gray-900">
//                             {stageTotal.totalDeals}
//                           </span>
//                           <span className="text-xs text-gray-600">
//                             ₹{(stageTotal.totalAmount || 0).toLocaleString('en-IN')}
//                           </span>
//                         </div>
//                       </td>
//                     );
//                   })}
//                   <td className="px-6 py-4 text-center">
//                     <span className="text-sm text-gray-900">{totals.deals}</span>
//                   </td>
//                   <td className="px-6 py-4 text-center">
//                     <span className="text-sm text-gray-900">
//                       ₹{(totals.amount || 0).toLocaleString('en-IN')}
//                     </span>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalespersonStageDashboard;

// components/dashboard/SalespersonStageDashboard.jsx
// components/dashboard/SalespersonStageDashboard.jsx

// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { Award, Target, Download, Users, ArrowUpDown, ChevronUp, ChevronDown } from 'lucide-react';
// import { HiInboxStack } from "react-icons/hi2";
// import api from '../../common/apiClient';
// import SummaryApi from '../../common/SummaryApi';
// import { exportToPDF, exportToExcel } from './ExportData';
// import { Menu } from '@headlessui/react';
// import { SalespersonDashboardSkeleton } from './SkeletonLoader';

// const SalespersonStageDashboard = ({ viewType = 'all', userId = null, userName = '', tabId = '' }) => {
//   // Create unique state key based on viewType AND component name
//   const componentKey = 'salespersonDashboard';
//   const contextKey = tabId || viewType; // Use tabId if provided, otherwise fallback to viewType
//   const stateKey = `${componentKey}_${contextKey}`;
  
//   // Update all state declarations to use the new stateKey
//   const [activeTab, setActiveTab] = useState(() => {
//     const saved = sessionStorage.getItem(`${stateKey}_activeTab`);
//     return saved || 'all';
//   });
  
//   const [filterType, setFilterType] = useState(() => {
//     const saved = sessionStorage.getItem(`${stateKey}_filterType`);
//     return saved || 'fiscal';
//   });
  
//   const [dateRange, setDateRange] = useState(() => {
//     const saved = sessionStorage.getItem(`${stateKey}_dateRange`);
//     return saved ? JSON.parse(saved) : { from: '', to: '' };
//   });

//   const [divisions, setDivisions] = useState([]);
//   const [salespersonData, setSalespersonData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   // const [searchTerm, setSearchTerm] = useState('');
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'desc' });
//   const [orgDetails, setOrgDetails] = useState({});
//   const [users, setUsers] = useState([]);
//   const [selectedUser, setSelectedUser] = useState('');
//   // Always show division tabs for both views
//   const showDivisionTabs = true;
//   const isUserView = viewType === 'user';

//   // Save filter states to sessionStorage with unique keys
//   useEffect(() => {
//     sessionStorage.setItem(`${stateKey}_activeTab`, activeTab);
//   }, [activeTab, stateKey]);

//   useEffect(() => {
//     sessionStorage.setItem(`${stateKey}_filterType`, filterType);
//   }, [filterType, stateKey]);

//   useEffect(() => {
//     sessionStorage.setItem(`${stateKey}_dateRange`, JSON.stringify(dateRange));
//   }, [dateRange, stateKey]);

//   // Update the reset state useEffect
//   useEffect(() => {
//     const savedTab = sessionStorage.getItem(`${stateKey}_activeTab`);
//     setActiveTab(savedTab || 'all');
    
//     const savedFilter = sessionStorage.getItem(`${stateKey}_filterType`);
//     setFilterType(savedFilter || 'fiscal');
    
//     const savedRange = sessionStorage.getItem(`${stateKey}_dateRange`);
//     setDateRange(savedRange ? JSON.parse(savedRange) : { from: '', to: '' });
//   }, [viewType, tabId, stateKey]);

//   // Rest of the component remains the same...
//   // Memoized title based on viewType
//   const dashboardTitle = useMemo(() => {
//     if (isUserView && userName) {
//       return `${userName}'s Performance Dashboard`;
//     }
//     return 'Salesperson Performance Dashboard';
//   }, [isUserView, userName]);

//   const fetchOrganization = useCallback(async () => {
//     try {
//       const response = await api.get(SummaryApi.getOrgDetails.url);
//       if (response.data.success) {
//         setOrgDetails(response.data.organization);
//       }
//     } catch (error) {
//       console.error("Error fetching organization:", error);
//     }
//   }, []);

//   // Single useEffect for organization fetch
//   useEffect(() => {
//     fetchOrganization();
//   }, [fetchOrganization]);

//   // Memoized computations
//   const filteredAndSortedData = useMemo(() => {
//     let filtered = salespersonData
//     // .filter(person => 
//     //   person.userName.toLowerCase().includes(searchTerm.toLowerCase())
//     // );

//     // Only sort if a sort key is explicitly selected
//     if (sortConfig.key) {
//       return filtered.sort((a, b) => {
//         let aValue = a[sortConfig.key];
//         let bValue = b[sortConfig.key];

//         if (sortConfig.key.includes('stage_')) {
//           const stageId = sortConfig.key.replace('stage_', '');
//           const aStage = a.stages.find(s => s.stageId === stageId);
//           const bStage = b.stages.find(s => s.stageId === stageId);
//           aValue = aStage ? aStage.totalAmount : 0;
//           bValue = bStage ? bStage.totalAmount : 0;
//         }

//         return sortConfig.direction === 'asc' 
//           ? aValue > bValue ? 1 : -1 
//           : aValue < bValue ? 1 : -1;
//       });
//     }
    
//     // Return the filtered data without sorting
//     return filtered;
//   }, [salespersonData, sortConfig]);

//   // Fetch divisions
//   const fetchDivisions = useCallback(async () => {
//     try {
//       const response = await api.get(SummaryApi.getAllDivisions.url);
//       if (response.data.success) {
//         setDivisions(response.data.data || []);
//       }
//     } catch (error) {
//       console.error('Failed to fetch divisions:', error);
//     }
//   }, []);

//   // Fetch salesperson stage data with viewType support
//   const fetchSalespersonStageData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams({
//         filterType,
//         ...(selectedUser && { userId: selectedUser }),
//         ...(activeTab !== 'all' && { divisionId: activeTab }),
//         ...(dateRange.from && { fromDate: dateRange.from }),
//         ...(dateRange.to && { toDate: dateRange.to })
//       });

//       const response = await api.get(`${SummaryApi.getSalespersonStageDashboard.url}?${params.toString()}`);
//       if (response.data.success) {
//         setSalespersonData(response.data.data || []);
//       }
//     } catch (error) {
//       console.error('Failed to fetch salesperson stage data:', error);
//     } finally {
//       setLoading(false);
//     }
//   }, [activeTab, filterType, dateRange, selectedUser]);

//   const fetchUsers = useCallback(async () => {
//     try {
//       const response = await api.get(
//         SummaryApi.getAllUsers.url
//       );

//       if (response.data.success) {
//         setUsers(response.data.data || []);
//       }
//     } catch (error) {
//       console.error("Failed to fetch users:", error);
//     }
//   }, []);

//   // Combined useEffect for data fetching
//   useEffect(() => {
//     fetchDivisions();
//   }, [fetchDivisions]);

//   useEffect(() => {
//     fetchUsers();
//   }, [fetchUsers]);

//   useEffect(() => {
//     fetchSalespersonStageData();
//   }, [fetchSalespersonStageData]);

//   const stageTotals = useMemo(() => {
//     return salespersonData.reduce((acc, person) => {
//       person.stages.forEach(stage => {
//         if (!acc[stage.stageId]) {
//           acc[stage.stageId] = {
//             ...stage,
//             totalDeals: 0,
//             totalAmount: 0
//           };
//         }
//         acc[stage.stageId].totalDeals += stage.totalDeals;
//         acc[stage.stageId].totalAmount += stage.totalAmount;
//       });
//       return acc;
//     }, {});
//   }, [salespersonData]);

//   const totals = useMemo(() => 
//     salespersonData.reduce((acc, person) => ({
//       deals: acc.deals + person.totalDeals,
//       amount: acc.amount + person.totalAmount
//     }), { deals: 0, amount: 0 }),
//     [salespersonData]
//   );

//   const allStages = useMemo(() => {
//     return salespersonData.length > 0 ? salespersonData[0].stages : [];
//   }, [salespersonData]);

//   const handleExport = useCallback((format) => {
//     const divisionName = activeTab === 'all' 
//       ? 'All Divisions' 
//       : divisions.find(d => d._id === activeTab)?.name || activeTab;

//     if (format === 'pdf') {
//       exportToPDF(filteredAndSortedData, allStages, totals, filterType, divisionName, orgDetails);
//     } else if (format === 'excel') {
//       exportToExcel(filteredAndSortedData, allStages, totals, filterType, divisionName);
//     }
//   }, [activeTab, divisions, filteredAndSortedData, allStages, totals, filterType, orgDetails]);

//   // Sort handler
//   const handleSort = useCallback((key) => {
//     setSortConfig(prev => ({
//       key,
//       direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
//     }));
//   }, []);

//   const SortIcon = ({ columnKey }) => {
//     if (sortConfig.key !== columnKey) {
//       return <ArrowUpDown className="h-3 w-3 text-gray-400" />;
//     }
//     return sortConfig.direction === 'asc' 
//       ? <ChevronUp className="h-3 w-3 text-red-600" />
//       : <ChevronDown className="h-3 w-3 text-red-600" />;
//   };

//   if (loading) {
//     return <SalespersonDashboardSkeleton variant="wave" />;
//   }

//   // Rest of the component JSX remains exactly the same...
//   return (
//     <div className="space-y-6">
//       {/* Rest of the JSX remains exactly the same as in your original code */}
//       {/* Header */}
//       <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900">{dashboardTitle}</h1>
//           <p className="text-gray-600 mt-1">
//             {isUserView 
//               ? 'Track your personal sales performance across stages'
//               : 'Track individual sales performance across stages'
//             }
//           </p>
//         </div>
        
//         <div className="flex flex-wrap items-center gap-3">
//           {/* Search - Only show in 'all' view */}
//           {!isUserView && (
//             <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">

//               {/* Search */}
//               {/* <div className="relative flex-1 sm:w-64">
//                 <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />

//                 <input
//                   type="text"
//                   placeholder="Search salesperson..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//                 />
//               </div> */}

//               {/* User Filter */}
//               <select
//                 value={selectedUser}
//                 onChange={(e) => setSelectedUser(e.target.value)}
//                 className="w-full sm:w-56 px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//               >
//                 <option value="">All Users</option>

//                 {users.map((user) => (
//                   <option key={user._id} value={user._id}>
//                     {user.firstName} {user.lastName}
//                   </option>
//                 ))}
//               </select>

//             </div>
//           )}

//           {/* Filter Type Selector */}
//           <select
//             value={filterType}
//             onChange={(e) => setFilterType(e.target.value)}
//             className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//           >
//             <option value="fiscal">Fiscal Year</option>
//             <option value="month">This Month</option>
//             <option value="year">This Year</option>
//             <option value="custom">Custom Range</option>
//           </select>

//           {/* Custom Date Range */}
//           {filterType === 'custom' && (
//             <>
//               <input
//                 type="date"
//                 value={dateRange.from}
//                 onChange={(e) => setDateRange(prev => ({ ...prev, from: e.target.value }))}
//                 className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//               />
//               <span className="text-gray-500">to</span>
//               <input
//                 type="date"
//                 value={dateRange.to}
//                 onChange={(e) => setDateRange(prev => ({ ...prev, to: e.target.value }))}
//                 className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
//               />
//             </>
//           )}

//           {/* Export Button */}
//           <Menu as="div" className="relative inline-block text-left">
//             <Menu.Button className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm">
//               <Download className="h-4 w-4 text-gray-600" />
//               Export
//               <ChevronDown className="h-4 w-4 text-gray-400" />
//             </Menu.Button>
            
//             <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
//               <div className="px-1 py-1">
//                 <Menu.Item>
//                   {({ active }) => (
//                     <button
//                       onClick={() => handleExport('pdf')}
//                       className={`${
//                         active ? 'bg-red-50 text-red-600' : 'text-gray-900'
//                       } group flex w-full items-center rounded-md px-3 py-2 text-sm transition-colors`}
//                     >
//                       <svg className="mr-3 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
//                           d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
//                       </svg>
//                       Export as PDF
//                     </button>
//                   )}
//                 </Menu.Item>
                
//                 <Menu.Item>
//                   {({ active }) => (
//                     <button
//                       onClick={() => handleExport('excel')}
//                       className={`${
//                         active ? 'bg-green-50 text-green-600' : 'text-gray-900'
//                       } group flex w-full items-center rounded-md px-3 py-2 text-sm transition-colors`}
//                     >
//                       <svg className="mr-3 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
//                           d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
//                       </svg>
//                       Export as Excel
//                     </button>
//                   )}
//                 </Menu.Item>
//               </div>
//             </Menu.Items>
//           </Menu>
//         </div>
//       </div>

//       {/* Division Tabs - Always show */}
//       {showDivisionTabs && (
//         <div className="border-b border-gray-200 overflow-x-auto">
//           <nav className="-mb-px flex space-x-8">
//             <button
//               onClick={() => setActiveTab('all')}
//               className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
//                 activeTab === 'all'
//                   ? 'border-red-600 text-red-600'
//                   : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//               }`}
//             >
//               All Divisions
//             </button>
            
//             {divisions.map(division => (
//               <button
//                 key={division._id}
//                 onClick={() => setActiveTab(division._id)}
//                 className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
//                   activeTab === division._id
//                     ? 'border-red-600 text-red-600'
//                     : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//               }`}
//               >
//                 {division.name}
//               </button>
//             ))}
//           </nav>
//         </div>
//       )}

//       {/* Rest of your JSX continues exactly the same... */}
//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//         <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <Users className="h-8 w-8 opacity-80" />
//             <span className="text-2xl font-bold">
//               {isUserView ? '1' : salespersonData.length}
//             </span>
//           </div>
//           <p className="text-sm opacity-90">
//             {isUserView ? 'Your Performance' : 'Active Salespersons'}
//           </p>
//         </div>

//         <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <Target className="h-8 w-8 opacity-80" />
//             <span className="text-2xl font-bold">{totals.deals}</span>
//           </div>
//           <p className="text-sm opacity-90">{isUserView ? 'Your Deals' : 'Total Deals'}</p>
//         </div>

//         <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white">
//           <div className="flex items-center justify-between mb-4">
//             <HiInboxStack className="h-8 w-8 opacity-80" />
//             <span className="text-xl font-bold">₹{(totals.amount || 0).toLocaleString('en-IN')}</span>
//           </div>
//           <p className="text-sm opacity-90">{isUserView ? 'Your Pipeline Value' : 'Total Pipeline Value'}</p>
//         </div>

//       {/* <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white">
//         <div className="flex items-center justify-between mb-4">
//           <Award className="h-8 w-8 opacity-80" />
//           <span className="text-lg font-bold">
//             {salespersonData.length > 0 ? salespersonData[0]?.userName.split(' ')[0] : '-'}
//           </span>
//         </div>
//         <p className="text-sm opacity-90">Top Performer</p>
//       </div> */}
//       <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white">
//       <div className="flex items-center gap-2 mb-3">
//         <Award className="h-6 w-6 opacity-80" />
//         <span className="text-lg font-bold">
//           {salespersonData.length > 0 ? salespersonData[0]?.userName.split(' ')[0] : '-'}
//         </span>
//       </div>
      
//       {salespersonData.length > 0 && (
//         <div className="space-y-1">
//           {/* <p className="text-sm font-semibold">S1 Performance</p> */}
//           <div className="text-xs font-medium">
//             <p>Vol/Val:</p>
//             <p>
//               {salespersonData[0]?.stages.find(s => s.stageId === "S1")?.totalDeals || 0} - 
//               ₹{(salespersonData[0]?.stages.find(s => s.stageId === "S1")?.totalAmount || 0).toLocaleString('en-IN')}
//             </p>
//           </div>
//         </div>
//       )}
      
//       <p className="text-sm opacity-90 mt-3">Top Performer</p>
//     </div>

//       </div>

//       {/* Pipeline Overview */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//         <h2 className="text-lg font-semibold text-gray-900 mb-4">
//           {isUserView ? 'My Pipeline Overview' : 'Pipeline Overview'}
//         </h2>
//         <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-3">
//           {Object.values(stageTotals).map(stage => (
//             <div
//               key={stage.stageId}
//               className="text-center p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow"
//               style={{
//                 borderTopColor: stage.color,
//                 borderTopWidth: "3px",
//               }}
//             >
//               <div className="flex items-center justify-center gap-2 mb-2">
//                 <div
//                   className="w-3 h-3 rounded-full"
//                   style={{ backgroundColor: stage.color }}
//                 />

//                 <span className="text-xs font-semibold text-gray-700">
//                   #{stage.orderSequence}
//                 </span>
//               </div>

//               <p className="text-xs text-gray-600 mb-1">
//                 {stage.stageName}
//               </p>

//               <p className="text-xl font-bold text-gray-900">
//                 {stage.totalDeals}
//               </p>

//               <p className="text-xs text-gray-500 mt-1">
//                 ₹{(stage.totalAmount || 0).toLocaleString("en-IN")}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Performance Table */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
//         <div className="p-6 border-b border-gray-200">
//           <h2 className="text-lg font-semibold text-gray-900">
//             {isUserView ? 'My Performance Details' : 'Individual Performance Details'}
//           </h2>
//         </div>
        
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="bg-gray-50 border-b border-gray-200">
//               <tr>
//                 <th className="px-6 py-3 text-left">
//                   <button
//                     onClick={() => handleSort('userName')}
//                     className="flex items-center gap-1 text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
//                   >
//                     Salesperson
//                     <SortIcon columnKey="userName" />
//                   </button>
//                 </th>
//                 {allStages.map(stage => (
//                   <th key={stage.stageId} className="px-4 py-3 text-center">
//                     <button
//                       onClick={() => handleSort(`stage_${stage.stageId}`)}
//                       className="flex flex-col items-center gap-1 mx-auto group"
//                     >
//                       <div className="flex items-center gap-1">
//                         <div 
//                           className="w-2 h-2 rounded-full"
//                           style={{ backgroundColor: stage.color }}
//                         />
//                         <span className="text-xs font-medium text-gray-700 uppercase tracking-wider group-hover:text-red-600">
//                           {stage.stageId}
//                         </span>
//                         <SortIcon columnKey={`stage_${stage.stageId}`} />
//                       </div>
//                       <span className="text-[10px] text-gray-500 font-normal">
//                         {stage.stageName}
//                       </span>
//                     </button>
//                   </th>
//                 ))}
//                 <th className="px-6 py-3 text-center">
//                   <button
//                     onClick={() => handleSort('totalDeals')}
//                     className="flex items-center gap-1 mx-auto text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
//                   >
//                     Total Deals
//                     <SortIcon columnKey="totalDeals" />
//                   </button>
//                 </th>
//                 <th className="px-6 py-3 text-center">
//                   <button
//                     onClick={() => handleSort('totalAmount')}
//                     className="flex items-center gap-1 mx-auto text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
//                   >
//                     Total Amount
//                     <SortIcon columnKey="totalAmount" />
//                   </button>
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {filteredAndSortedData.length === 0 ? (
//                 <tr>
//                   <td colSpan={allStages.length + 3} className="px-6 py-12 text-center text-gray-500">
//                     No salesperson data found
//                   </td>
//                 </tr>
//               ) : (
//                 filteredAndSortedData.map((person, index) => (
//                   <tr key={person._id} className="hover:bg-gray-50 transition-colors">
//                     <td className="px-6 py-4">
//                       <div className="flex items-center gap-3">
//                         <div className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium ${
//                           index < 3 ? 'bg-red-100 text-red-600' : 'bg-gray-100 text-gray-600'
//                         }`}>
//                           {index + 1}
//                         </div>
//                         <div>
//                           <p className="text-sm font-medium text-gray-900">{person.userName}</p>
//                         </div>
//                       </div>
//                     </td>
//                     {person.stages.map(stage => (
//                       <td key={stage.stageId} className="px-4 py-4 text-center">
//                         {stage.totalDeals > 0 ? (
//                           <div className="inline-flex flex-col">
//                             <span className="text-sm font-medium text-gray-900">
//                               {stage.totalDeals}
//                             </span>
//                             <span className="text-xs text-gray-500">
//                               ₹{(stage.totalAmount || 0).toLocaleString('en-IN')}
//                             </span>
//                           </div>
//                         ) : (
//                           <span className="text-sm text-gray-400">-</span>
//                         )}
//                       </td>
//                     ))}
//                     <td className="px-6 py-4 text-center">
//                       <span className="text-sm font-bold text-gray-900">{person.totalDeals}</span>
//                     </td>
//                     <td className="px-6 py-4 text-center">
//                       <span className="text-sm font-bold text-gray-900">
//                         ₹{(person.totalAmount || 0).toLocaleString('en-IN')}
//                       </span>
//                     </td>
//                   </tr>
//                 ))
//               )}
              
//               {/* Total Row */}
//               {filteredAndSortedData.length > 0 && (
//                 <tr className="bg-gray-50 font-semibold">
//                   <td className="px-6 py-4">
//                     <span className="text-sm text-gray-900">Total</span>
//                   </td>
//                   {allStages.map(stage => {
//                     const stageTotal = stageTotals[stage.stageId] || { totalDeals: 0, totalAmount: 0 };
//                     return (
//                       <td key={stage.stageId} className="px-4 py-4 text-center">
//                         <div className="inline-flex flex-col">
//                           <span className="text-sm text-gray-900">
//                             {stageTotal.totalDeals}
//                           </span>
//                           <span className="text-xs text-gray-600">
//                             ₹{(stageTotal.totalAmount || 0).toLocaleString('en-IN')}
//                           </span>
//                         </div>
//                       </td>
//                     );
//                   })}
//                   <td className="px-6 py-4 text-center">
//                     <span className="text-sm text-gray-900">{totals.deals}</span>
//                   </td>
//                   <td className="px-6 py-4 text-center">
//                     <span className="text-sm text-gray-900">
//                       ₹{(totals.amount || 0).toLocaleString('en-IN')}
//                     </span>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalespersonStageDashboard;


import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Award, Target, Download, Users, ArrowUpDown, ChevronUp, ChevronDown } from 'lucide-react';
import { HiInboxStack } from "react-icons/hi2";
import api from '../../common/apiClient';
import SummaryApi from '../../common/SummaryApi';
import { exportToPDF, exportToExcel } from './ExportData';
import { Menu } from '@headlessui/react';
import { SalespersonDashboardSkeleton } from './SkeletonLoader';
import { Filter } from "lucide-react";
import FilterDrawer from "./FilterDrawer";
const SalespersonStageDashboard = ({ viewType = 'all', userId = null, userName = '', tabId = '' }) => {
  // Create unique state key based on viewType AND component name
  const componentKey = 'salespersonDashboard';
  const contextKey = tabId || viewType; // Use tabId if provided, otherwise fallback to viewType
  const stateKey = `${componentKey}_${contextKey}`;
  
  // Update all state declarations to use the new stateKey
  const [activeTab, setActiveTab] = useState(() => {
    const saved = sessionStorage.getItem(`${stateKey}_activeTab`);
    return saved || 'all';
  });
  
  const [filterType, setFilterType] = useState(() => {
    const saved = sessionStorage.getItem(`${stateKey}_filterType`);
    return saved || 'fiscal';
  });
  
  const [dateRange, setDateRange] = useState(() => {
    const saved = sessionStorage.getItem(`${stateKey}_dateRange`);
    return saved ? JSON.parse(saved) : { from: '', to: '' };
  });

  const [divisions, setDivisions] = useState([]);
  const [salespersonData, setSalespersonData] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'desc' });
  const [orgDetails, setOrgDetails] = useState({});
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  // Always show division tabs for both views
  const showDivisionTabs = true;
  const isUserView = viewType === 'user';
  const [showFilters, setShowFilters] = useState(false);
  const [tempUser, setTempUser] = useState("");
  const [tempFilterType, setTempFilterType] = useState("fiscal");

  const [tempDateRange, setTempDateRange] = useState({
    from: "",
    to: "",
  });
  // Save filter states to sessionStorage with unique keys
  useEffect(() => {
    sessionStorage.setItem(`${stateKey}_activeTab`, activeTab);
  }, [activeTab, stateKey]);

  useEffect(() => {
    sessionStorage.setItem(`${stateKey}_filterType`, filterType);
  }, [filterType, stateKey]);

  useEffect(() => {
    sessionStorage.setItem(`${stateKey}_dateRange`, JSON.stringify(dateRange));
  }, [dateRange, stateKey]);

  // Update the reset state useEffect
  useEffect(() => {
    const savedTab = sessionStorage.getItem(`${stateKey}_activeTab`);
    setActiveTab(savedTab || 'all');
    
    const savedFilter = sessionStorage.getItem(`${stateKey}_filterType`);
    setFilterType(savedFilter || 'fiscal');
    
    const savedRange = sessionStorage.getItem(`${stateKey}_dateRange`);
    setDateRange(savedRange ? JSON.parse(savedRange) : { from: '', to: '' });
  }, [viewType, tabId, stateKey]);

  // Rest of the component remains the same...
  // Memoized title based on viewType
  const dashboardTitle = useMemo(() => {
    if (isUserView && userName) {
      return `${userName}'s Performance Dashboard`;
    }
    return 'Salesperson Performance Dashboard';
  }, [isUserView, userName]);

  const fetchOrganization = useCallback(async () => {
    try {
      const response = await api.get(SummaryApi.getOrgDetails.url);
      if (response.data.success) {
        setOrgDetails(response.data.organization);
      }
    } catch (error) {
      console.error("Error fetching organization:", error);
    }
  }, []);

  // Single useEffect for organization fetch
  useEffect(() => {
    fetchOrganization();
  }, [fetchOrganization]);

  // Memoized computations
  const filteredAndSortedData = useMemo(() => {
    let filtered = salespersonData
    // .filter(person => 
    //   person.userName.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    // Only sort if a sort key is explicitly selected
    if (sortConfig.key) {
      return filtered.sort((a, b) => {
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        if (sortConfig.key.includes('stage_')) {
          const stageId = sortConfig.key.replace('stage_', '');
          const aStage = a.stages.find(s => s.stageId === stageId);
          const bStage = b.stages.find(s => s.stageId === stageId);
          aValue = aStage ? aStage.totalAmount : 0;
          bValue = bStage ? bStage.totalAmount : 0;
        }

        return sortConfig.direction === 'asc' 
          ? aValue > bValue ? 1 : -1 
          : aValue < bValue ? 1 : -1;
      });
    }
    
    // Return the filtered data without sorting
    return filtered;
  }, [salespersonData, sortConfig]);

  // Fetch divisions
  const fetchDivisions = useCallback(async () => {
    try {
      const response = await api.get(SummaryApi.getAllDivisions.url);
      if (response.data.success) {
        setDivisions(response.data.data || []);
      }
    } catch (error) {
      console.error('Failed to fetch divisions:', error);
    }
  }, []);

  // Fetch salesperson stage data with viewType support
  const fetchSalespersonStageData = useCallback(async () => {
    setLoading(true);
    try {
      // const params = new URLSearchParams({
      //   filterType,
      //   ...(selectedUser && { userId: selectedUser }),
      //   ...(activeTab !== 'all' && { divisionId: activeTab }),
      //   ...(dateRange.from && { fromDate: dateRange.from }),
      //   ...(dateRange.to && { toDate: dateRange.to })
      // });
      const params = new URLSearchParams({
        filterType,
        ...(isUserView ? { userId } : selectedUser ? { userId: selectedUser } : {}),
        ...(activeTab !== "all" && {
          divisionId: activeTab,
        }),
        ...(dateRange.from && {
          fromDate: dateRange.from,
        }),
        ...(dateRange.to && {
          toDate: dateRange.to,
        }),
      });
      const response = await api.get(`${SummaryApi.getSalespersonStageDashboard.url}?${params.toString()}`);
      if (response.data.success) {
        setSalespersonData(response.data.data || []);
      }
    } catch (error) {
      console.error('Failed to fetch salesperson stage data:', error);
    } finally {
      setLoading(false);
    }
  }, [filterType, isUserView, userId, selectedUser, activeTab, dateRange.from, dateRange.to]);

  const fetchUsers = useCallback(async () => {
    try {
      const response = await api.get(SummaryApi.executiveUsers.url);

      if (response.data.success) {
        const usersData = response.data.data || [];

        const formattedUsers = usersData.map((user) => {
          const nameParts = (user.fullName || "").trim().split(" ");

          return {
            ...user,
            _id: user.userId,
            firstName: nameParts[0] || "",
            lastName: nameParts.slice(1).join(" ") || "",
          };
        });

        setUsers(formattedUsers);
      }
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  }, []);

  // Combined useEffect for data fetching
  useEffect(() => {
    fetchDivisions();
  }, [fetchDivisions]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  useEffect(() => {
    fetchSalespersonStageData();
  }, [fetchSalespersonStageData]);

  const stageTotals = useMemo(() => {
    return salespersonData.reduce((acc, person) => {
      person.stages.forEach(stage => {
        if (!acc[stage.stageId]) {
          acc[stage.stageId] = {
            ...stage,
            totalDeals: 0,
            totalAmount: 0
          };
        }
        acc[stage.stageId].totalDeals += stage.totalDeals;
        acc[stage.stageId].totalAmount += stage.totalAmount;
      });
      return acc;
    }, {});
  }, [salespersonData]);

  const totals = useMemo(() => 
    salespersonData.reduce((acc, person) => ({
      deals: acc.deals + person.totalDeals,
      amount: acc.amount + person.totalAmount
    }), { deals: 0, amount: 0 }),
    [salespersonData]
  );

  const allStages = useMemo(() => {
    return salespersonData.length > 0 ? salespersonData[0].stages : [];
  }, [salespersonData]);

  const handleExport = useCallback((format) => {
    const divisionName = activeTab === 'all' 
      ? 'All Divisions' 
      : divisions.find(d => d._id === activeTab)?.name || activeTab;

    if (format === 'pdf') {
      exportToPDF(filteredAndSortedData, allStages, totals, filterType, divisionName, orgDetails);
    } else if (format === 'excel') {
      exportToExcel(filteredAndSortedData, allStages, totals, filterType, divisionName);
    }
  }, [activeTab, divisions, filteredAndSortedData, allStages, totals, filterType, orgDetails]);

  // Sort handler
  const handleSort = useCallback((key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  }, []);

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return <ArrowUpDown className="h-3 w-3 text-gray-400" />;
    }
    return sortConfig.direction === 'asc' 
      ? <ChevronUp className="h-3 w-3 text-red-600" />
      : <ChevronDown className="h-3 w-3 text-red-600" />;
  };

  if (loading) {
    return <SalespersonDashboardSkeleton variant="wave" />;
  }

  // Rest of the component JSX remains exactly the same...
  return (
    <div className="space-y-4">
      {/* Rest of the JSX remains exactly the same as in your original code */}
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{dashboardTitle}</h1>
          <p className="text-gray-600 mt-1">
            {isUserView 
              ? 'Track your personal sales performance across stages'
              : 'Track individual sales performance across stages'
            }
          </p>
        </div>
        
        <div className="flex flex-wrap items-center gap-3">
        <button
          onClick={() => {
            setTempUser(selectedUser);
            setTempFilterType(filterType);
            setTempDateRange(dateRange);
            setShowFilters(true);
          }}
          className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          <Filter size={16} />
          Filters
        </button>

          {/* Export Button */}
          <Menu as="div" className="relative inline-block text-left">
            <Menu.Button className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm">
              <Download className="h-4 w-4 text-gray-600" />
              Export
              <ChevronDown className="h-4 w-4 text-gray-400" />
            </Menu.Button>
            
            <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
              <div className="px-1 py-1">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => handleExport('pdf')}
                      className={`${
                        active ? 'bg-red-50 text-red-600' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-3 py-2 text-sm transition-colors`}
                    >
                      <svg className="mr-3 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                          d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                      </svg>
                      Export as PDF
                    </button>
                  )}
                </Menu.Item>
                
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => handleExport('excel')}
                      className={`${
                        active ? 'bg-green-50 text-green-600' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-3 py-2 text-sm transition-colors`}
                    >
                      <svg className="mr-3 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                          d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
                      </svg>
                      Export as Excel
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Menu>
        </div>
      </div>

      {/* Division Tabs - Always show */}
      {showDivisionTabs && (
        <div className="border-b border-gray-200 overflow-x-auto">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab('all')}
              className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
                activeTab === 'all'
                  ? 'border-red-600 text-red-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              All Divisions
            </button>
            
            {divisions.map(division => (
              <button
                key={division._id}
                onClick={() => setActiveTab(division._id)}
                className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
                  activeTab === division._id
                    ? 'border-red-600 text-red-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              >
                {division.name}
              </button>
            ))}
          </nav>
        </div>
      )}

      {/* Rest of your JSX continues exactly the same... */}
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-xl p-6 text-white">
          <div className="flex items-center justify-between mb-4">
            <Users className="h-8 w-8 opacity-80" />
            <span className="text-2xl font-bold">
              {isUserView ? '1' : salespersonData.length}
            </span>
          </div>
          <p className="text-sm opacity-90">
            {isUserView ? 'Your Performance' : 'Active Salespersons'}
          </p>
        </div>

        <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 text-white">
          <div className="flex items-center justify-between mb-4">
            <Target className="h-8 w-8 opacity-80" />
            <span className="text-2xl font-bold">{totals.deals}</span>
          </div>
          <p className="text-sm opacity-90">{isUserView ? 'Your Deals' : 'Total Deals'}</p>
        </div>

        <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white">
          <div className="flex items-center justify-between mb-4">
            <HiInboxStack className="h-8 w-8 opacity-80" />
            <span className="text-xl font-bold">₹{(totals.amount || 0).toLocaleString('en-IN')}</span>
          </div>
          <p className="text-sm opacity-90">{isUserView ? 'Your Pipeline Value' : 'Total Pipeline Value'}</p>
        </div>

      {/* <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white">
        <div className="flex items-center justify-between mb-4">
          <Award className="h-8 w-8 opacity-80" />
          <span className="text-lg font-bold">
            {salespersonData.length > 0 ? salespersonData[0]?.userName.split(' ')[0] : '-'}
          </span>
        </div>
        <p className="text-sm opacity-90">Top Performer</p>
      </div> */}
      <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white">
      <div className="flex items-center gap-2 mb-3">
        <Award className="h-6 w-6 opacity-80" />
        <span className="text-lg font-bold">
          {salespersonData.length > 0 ? salespersonData[0]?.userName.split(' ')[0] : '-'}
        </span>
      </div>
      
      {salespersonData.length > 0 && (
        <div className="space-y-1">
          {/* <p className="text-sm font-semibold">S1 Performance</p> */}
          <div className="text-xs font-medium">
            <p>Vol/Val:</p>
            <p>
              {salespersonData[0]?.stages.find(s => s.stageId === "S1")?.totalDeals || 0} - 
              ₹{(salespersonData[0]?.stages.find(s => s.stageId === "S1")?.totalAmount || 0).toLocaleString('en-IN')}
            </p>
          </div>
        </div>
      )}
      
      <p className="text-sm opacity-90 mt-3">Top Performer</p>
    </div>

      </div>

      {/* Pipeline Overview */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          {isUserView ? 'My Pipeline Overview' : 'Pipeline Overview'}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-3">
          {Object.values(stageTotals).map(stage => (
            <div
              key={stage.stageId}
              className="text-center p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow"
              style={{
                borderTopColor: stage.color,
                borderTopWidth: "3px",
              }}
            >
              <div className="flex items-center justify-center gap-2 mb-2">
                <div
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: stage.color }}
                />

                <span className="text-xs font-semibold text-gray-700">
                  #{stage.orderSequence}
                </span>
              </div>

              <p className="text-xs text-gray-600 mb-1">
                {stage.stageName}
              </p>

              <p className="text-xl font-bold text-gray-900">
                {stage.totalDeals}
              </p>

              <p className="text-xs text-gray-500 mt-1">
                ₹{(stage.totalAmount || 0).toLocaleString("en-IN")}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Performance Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">
            {isUserView ? 'My Performance Details' : 'Individual Performance Details'}
          </h2>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-3 text-left">
                  <button
                    onClick={() => handleSort('userName')}
                    className="flex items-center gap-1 text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
                  >
                    Salesperson
                    <SortIcon columnKey="userName" />
                  </button>
                </th>
                {allStages.map(stage => (
                  <th key={stage.stageId} className="px-4 py-3 text-center">
                    <button
                      onClick={() => handleSort(`stage_${stage.stageId}`)}
                      className="flex flex-col items-center gap-1 mx-auto group"
                    >
                      <div className="flex items-center gap-1">
                        <div 
                          className="w-2 h-2 rounded-full"
                          style={{ backgroundColor: stage.color }}
                        />
                        <span className="text-xs font-medium text-gray-700 uppercase tracking-wider group-hover:text-red-600">
                          {stage.stageId}
                        </span>
                        <SortIcon columnKey={`stage_${stage.stageId}`} />
                      </div>
                      <span className="text-[10px] text-gray-500 font-normal">
                        {stage.stageName}
                      </span>
                    </button>
                  </th>
                ))}
                <th className="px-6 py-3 text-center">
                  <button
                    onClick={() => handleSort('totalDeals')}
                    className="flex items-center gap-1 mx-auto text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
                  >
                    Total Deals
                    <SortIcon columnKey="totalDeals" />
                  </button>
                </th>
                <th className="px-6 py-3 text-center">
                  <button
                    onClick={() => handleSort('totalAmount')}
                    className="flex items-center gap-1 mx-auto text-xs font-medium text-gray-700 uppercase tracking-wider hover:text-red-600"
                  >
                    Total Amount
                    <SortIcon columnKey="totalAmount" />
                  </button>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {filteredAndSortedData.length === 0 ? (
                <tr>
                  <td colSpan={allStages.length + 3} className="px-6 py-12 text-center text-gray-500">
                    No salesperson data found
                  </td>
                </tr>
              ) : (
                filteredAndSortedData.map((person, index) => (
                  <tr key={person._id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium ${
                          index < 3 ? 'bg-red-100 text-red-600' : 'bg-gray-100 text-gray-600'
                        }`}>
                          {index + 1}
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900">{person.userName}</p>
                        </div>
                      </div>
                    </td>
                    {person.stages.map(stage => (
                      <td key={stage.stageId} className="px-4 py-4 text-center">
                        {stage.totalDeals > 0 ? (
                          <div className="inline-flex flex-col">
                            <span className="text-sm font-medium text-gray-900">
                              {stage.totalDeals}
                            </span>
                            <span className="text-xs text-gray-500">
                              ₹{(stage.totalAmount || 0).toLocaleString('en-IN')}
                            </span>
                          </div>
                        ) : (
                          <span className="text-sm text-gray-400">-</span>
                        )}
                      </td>
                    ))}
                    <td className="px-6 py-4 text-center">
                      <span className="text-sm font-bold text-gray-900">{person.totalDeals}</span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className="text-sm font-bold text-gray-900">
                        ₹{(person.totalAmount || 0).toLocaleString('en-IN')}
                      </span>
                    </td>
                  </tr>
                ))
              )}
              
              {/* Total Row */}
              {filteredAndSortedData.length > 0 && (
                <tr className="bg-gray-50 font-semibold">
                  <td className="px-6 py-4">
                    <span className="text-sm text-gray-900">Total</span>
                  </td>
                  {allStages.map(stage => {
                    const stageTotal = stageTotals[stage.stageId] || { totalDeals: 0, totalAmount: 0 };
                    return (
                      <td key={stage.stageId} className="px-4 py-4 text-center">
                        <div className="inline-flex flex-col">
                          <span className="text-sm text-gray-900">
                            {stageTotal.totalDeals}
                          </span>
                          <span className="text-xs text-gray-600">
                            ₹{(stageTotal.totalAmount || 0).toLocaleString('en-IN')}
                          </span>
                        </div>
                      </td>
                    );
                  })}
                  <td className="px-6 py-4 text-center">
                    <span className="text-sm text-gray-900">{totals.deals}</span>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className="text-sm text-gray-900">
                      ₹{(totals.amount || 0).toLocaleString('en-IN')}
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <FilterDrawer
        isOpen={showFilters}
        onClose={() => setShowFilters(false)}

        showUserFilter={!isUserView}
        users={users}
        selectedUser={tempUser}
        onUserChange={setTempUser}

        showDateFilter={true}
        filterType={tempFilterType}
        onFilterTypeChange={setTempFilterType}

        dateRange={tempDateRange}
        onDateRangeChange={setTempDateRange}

        onReset={() => {
          setTempUser("");
          setTempFilterType("fiscal");

          setTempDateRange({
            from: "",
            to: "",
          });

          setSelectedUser("");
          setFilterType("fiscal");

          setDateRange({
            from: "",
            to: "",
          });
          setShowFilters(false);
        }}

        onApply={() => {
          setSelectedUser(tempUser);
          setFilterType(tempFilterType);
          setDateRange(tempDateRange);
        }}
      />
    </div>
  );
};

export default SalespersonStageDashboard;

